import ScrollReveal from '../components/ScrollReveal';
import {
  HoverSlider,
  HoverSliderImage,
  HoverSliderImageWrap,
  TextStaggerHover,
} from '../components/ui/animated-slideshow';

const SLIDES = [
  {
    id: 'slide-1',
    title: 'Estrategia de Marketing',
    description:
      'Desarrollamos planes integrales de marketing digital que alinean tus objetivos comerciales con tácticas efectivas para atraer, convertir y retener clientes.',
    imageUrl:
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&fit=crop',
  },
  {
    id: 'slide-2',
    title: 'Diseño de Marca',
    description:
      'Creamos identidades visuales que comunican la esencia de tu negocio. Desde el logotipo hasta la guía de estilo completa, cada elemento está diseñado para destacar.',
    imageUrl:
      'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800&fit=crop',
  },
  {
    id: 'slide-3',
    title: 'Diseño Web',
    description:
      'Diseñamos y desarrollamos sitios web modernos, rápidos y optimizados para conversión. Experiencias digitales que reflejan la calidad de tu marca.',
    imageUrl:
      'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&fit=crop',
  },
  {
    id: 'slide-4',
    title: 'Gestión de Redes Sociales',
    description:
      'Gestionamos tu presencia en redes sociales con contenido estratégico que genera engagement, construye comunidad y posiciona tu marca.',
    imageUrl:
      'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&fit=crop',
  },
];

export default function Services() {
  return (
    <div className="page">
      <section className="section">
        <div className="container">
          <ScrollReveal>
            <span className="section-label">Servicios</span>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h1 className="section-title">
              Soluciones que <span className="gradient-text">impulsan</span>
              <br />
              tu negocio.
            </h1>
          </ScrollReveal>
        </div>
      </section>

      <HoverSlider className="min-h-[70vh] place-content-center px-6 md:px-12 pb-24 bg-white text-neutral-900">
        <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-evenly gap-6 md:gap-12">
          <div className="flex flex-col space-y-4 md:space-y-6">
            {SLIDES.map((slide, index) => (
              <div key={slide.id} className="group">
                <TextStaggerHover
                  index={index}
                  className="cursor-pointer text-3xl md:text-5xl font-bold uppercase tracking-tighter"
                  text={slide.title}
                  style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                />
                <p className="max-w-md text-sm md:text-base text-neutral-500 mt-1 leading-relaxed">
                  {slide.description}
                </p>
              </div>
            ))}
          </div>
          <HoverSliderImageWrap className="max-w-lg w-full">
            {SLIDES.map((slide, index) => (
              <div key={slide.id}>
                <HoverSliderImage
                  index={index}
                  imageUrl={slide.imageUrl}
                  alt={slide.title}
                  className="w-full max-h-96 object-cover rounded-2xl"
                  loading="eager"
                  decoding="async"
                />
              </div>
            ))}
          </HoverSliderImageWrap>
        </div>
      </HoverSlider>
    </div>
  );
}
